module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-use-x-prefix-for-components-58.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-use-x-prefix-for-components.md
// module id = 757
// module chunks = 176